var _circle, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStickIcFirstbgCircle1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 522,
    height: 377,
    viewBox: "0 0 522 377",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 261,
    cy: 116,
    r: 211,
    stroke: "url(#paint0_linear_4491_1703)",
    strokeWidth: 100
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4491_1703",
    x1: 261,
    y1: -145,
    x2: 261,
    y2: 377,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.02
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStickIcFirstbgCircle1);
export default __webpack_public_path__ + "static/media/stick-ic-firstbg-circle1.788b1b0dc20d62cc71680c5b859d10ba.svg";
export { ForwardRef as ReactComponent };